import { render } from "./adminContents.vue?vue&type=template&id=ebd66bb2&scoped=true"
import script from "./adminContents.vue?vue&type=script&lang=js"
export * from "./adminContents.vue?vue&type=script&lang=js"

import "./adminContents.vue?vue&type=style&index=0&id=ebd66bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd66bb2"]])

export default __exports__